import React, { useState, useEffect, useContext } from "react";
import "../../OnCallLookUp/OnCallLookUpPage.scss";
import OnCallLookUpComponent from "../components/OnCallInput/OnCallLookUpInput";
import OnCallSearchByPage from "../components/OnCallSearchBy/onCallSearchBy";
import OnCallSearchResult from "../components/OnCallSearchResult/onCallSearchResult";
import { ReturnDataModel, SearchResultDataModel } from "../OnCallLookUpModel";
import { utilService } from "../../../services";
import { statusBoardService } from "../../StatusBoard/StatusBoard.service";
import { AddProviderContext } from "../../StatusBoard/components/StatusBoardTable/components/ExpandedCard/components/SBoardProvider/SBoardProvider";
import classNames from "classnames/bind";
import "./OnCalllookUpMainContent.scss";
import { SupportStaffProviderContext } from "../../StatusBoard/components/SupportStaff/SupportStaff";
import { useHistory, useLocation } from "react-router";
import _ from "lodash";


export interface ContainerProps {
  checkComponentName?: string;
  favCardData?: any;
  updateProviderList: (data: any) => void;
  showSearchResult: (data: boolean) => void;
  isResultPageDisplayed: (data: boolean) => void;
  siteID?: any;
  pId?: any;
  isFromCaseHistory?: any;
  updateDetailsPage?: any;
  providerList?:any
}

const OnCallLookUpMainContent: React.FC<ContainerProps> = (props) => {
  const AddProviderContextData = useContext(
    statusBoardService.selectedProviderPoupType
      ? SupportStaffProviderContext
      : AddProviderContext
  );

  const [canShowSearchByComp, setSearchByCompVisibillity] =
    useState<boolean>(false);
  const [canShowSearchResComp, setSearchResCompVisibility] =
    useState<boolean>(false);

  const [canShowInputComp, setInputCompVisibility] = useState<boolean>(true);
  const [dataFromInputComp, setInputCompData] = useState<any>(Object);
  const [fromComponent, setFromComponent] = useState<string>("");
  const [selctedGuid, setSelectedGuid] = useState<string>("");
  const [siteId, setSiteId] = useState<string>(
    statusBoardService.statusBoardData
      ? statusBoardService.statusBoardData[0].site?.siteId
      : ""
  );

  const [dataToSearchResComp, setDataToSearchResComp] =
    useState<SearchResultDataModel>(Object);
  const [screenType, setScreenType] = useState<string>("");
  const [resetSearchBy, setResetSearchBy] = useState<boolean>(false);
  const [favFlag,setFavFlag] = useState<boolean>(true)
  let history = useHistory();
  const location:any = useLocation();
 
  useEffect(() => {
    setSearchByCompVisibillity(false);
    setSearchResCompVisibility(false);
    props.isResultPageDisplayed(false);
    getScreenTypeString();
    getSiteId();
  }, []);

  useEffect(() => {
    if (AddProviderContextData.fromComponent) {
      mapOnCallResultData(selctedGuid);
    }
  }, [selctedGuid]);

  useEffect(() => {
    // setSearchResCompVisibility(false);
    props.isResultPageDisplayed(false);
    props.showSearchResult(false);
  }, [dataFromInputComp]);

  const getScreenTypeString = () => {
    setScreenType(utilService.getScreenSize());
  };
  const getSiteId = () => {
    if (statusBoardService.statusBoardData) {
      setSiteId(statusBoardService.statusBoardData[0].site.siteId);
    }

    if (props.siteID) {
      setSiteId(props.siteID);
    }
  };

  const mapOnCallResultData = (data: string) => {
    const resData: SearchResultDataModel = mapSelectedData(data);
    setDataToSearchResComp(resData);
    if (data) {
      setSearchResCompVisibility(true);
      props.isResultPageDisplayed(true);
      if (screenType === "small") {
        setSearchByCompVisibillity(false);
      }
    }
  };

  const mapSelectedData = (data: string) => {
    const returnFormat = {
      selectedUserid: data,
      DateSelected: dataFromInputComp.DateSelected!,
      TimeSelected: dataFromInputComp.TimeSelected!,
      SiteSelected: dataFromInputComp.SiteSelected!,
      OptionSelected: dataFromInputComp.OptionSelected!,
    };
    return returnFormat;
  };

  const getResFromInputComp = (dataFromParent: any) => {
    setInputCompData(dataFromParent);
    if (hasValue(dataFromParent)) {
      setSearchByCompVisibillity(true);
      if (screenType === "small") {
        setInputCompVisibility(false);
      }
    }
  };

  const hasValue = (data: ReturnDataModel) => {
    setResetSearchBy(false);
    if (
      (data.OptionSelected !== null || data.OptionSelected !== "") &&
      (data.DateSelected !== null || data.DateSelected !== "") &&
      (data.SiteSelected !== null || data.SiteSelected !== "") &&
      (data.TimeSelected !== null || data.TimeSelected !== "")
    ) {
      return true;
    }
    return false;
  };

  /**
   * This function will reset the searchby and searchResult component when site is reselected.
   */
  const resetData = () => {
    setSearchResCompVisibility(false);
    props.isResultPageDisplayed(false);
    setSearchByCompVisibillity(false);
  };

  const backBtnClicked = (flag: boolean) => {
    if (flag) {
      setSearchByCompVisibillity(true);
      const currentLocation: any = location;
      if (
        !_.isEmpty(currentLocation.state) &&
        !_.isEmpty(currentLocation.state.favCardData)
      ) {
        history.goBack();
      } else {
        setSearchResCompVisibility(false);
        setSearchByCompVisibillity(true);
        props.isResultPageDisplayed(false);
        setInputCompVisibility(false);
      }
    }
  };



  const searchByCancelAction = () => {
    setSearchByCompVisibillity(false);
    setSearchResCompVisibility(false);
    props.isResultPageDisplayed(false);
    setInputCompVisibility(true);
    setResetSearchBy(true);
    setFavFlag(false)
  };

  const searchByOptionChangedAction = () => {
    setSearchResCompVisibility(false);
    props.isResultPageDisplayed(false);
  };

  // To set the selected item from search by option  and to set the width of the sb modal width
  const onClickSearchBy = (data: any) => {
    if (data) {
      setSelectedGuid(data);
      props.showSearchResult(true);
    }
  };

  const updateDetailsPage = (ProviderUpdated: any) => {
    if (ProviderUpdated) {
      props.updateDetailsPage(ProviderUpdated);
    }
  };

  return (
    <div
      className={classNames({
        "ocl-content-conatiner": true,
        "ocl-padding": screenType !== "small" ? true : false,
      })}
    >
      {AddProviderContextData.fromComponent === "" && (
        <div
          className={`ocl-input-container ${
            screenType !== "small"
              ? "ocl-section-container"
              : canShowInputComp
              ? ""
              : "width-zero"
          }`}
        >
          <OnCallLookUpComponent
            getInputs={getResFromInputComp}
            siteResetClicked={resetData}
            dataFromComponent={fromComponent}
            siteId={siteId}
            resetSearchBy={resetSearchBy}
            favCardData={props.favCardData}
            setSelectedGuid={setSelectedGuid}
          />
        </div>
      )}
      {AddProviderContextData.fromComponent !== "" && (
        <div
          className={classNames({
            "ocl-input-container": true,
            "sb-ocl-input-container": true,
            "width-100": !canShowSearchResComp ? true : false,
            "update-view": canShowSearchResComp ? true : false,
          })}
        >
          <OnCallLookUpComponent
            getInputs={getResFromInputComp}
            siteResetClicked={resetData}
            dataFromComponent={fromComponent}
            siteId={siteId}
            resetSearchBy={resetSearchBy}
            setSelectedGuid={setSelectedGuid}
          />
        </div>
      )}
      {/* here conditionally (if it is called from statusBoard / oncall lookup main page) oncalllookup search by and oncall lookup component is shown */}
      {AddProviderContextData.fromComponent && (
        <div
          className={classNames({
            "flex-items": true,
          })}
        >
          <div
            className={classNames({
              "ocl-searchby-container": true,
              "ocl-search-by": true,
              "width-100": !canShowSearchResComp ? true : false,
              "update-view": canShowSearchResComp ? true : false,
            })}
          >
            <OnCallSearchByPage
              selectedData={dataFromInputComp}
              getCancelAction={(value) => searchByCancelAction()}
              getOptionChangedAction={(value) => {
                searchByOptionChangedAction();
              }}
              getOkAction={(data) => {
                onClickSearchBy(data);
              }}
            />
          </div>
          <div
            className={classNames({
              "ocl-search-result-container": true,
              "ocl-search-result":
                AddProviderContextData.fromComponent !== "" &&
                canShowSearchResComp
                  ? true
                  : false,
              "enable-width-ems": canShowSearchResComp ? true : false,
            })}
          >
            {canShowSearchResComp ? (
              <OnCallSearchResult
                dataFromComponent={fromComponent}
                userSelectedData={dataToSearchResComp}
                backBtnClicked={(flag: boolean) => backBtnClicked(flag)}
                pId={props.pId}
                isFromCaseHistory={props.isFromCaseHistory}
                updateAPICall={updateDetailsPage}
                providerList={props?.providerList}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      )}

      {AddProviderContextData.fromComponent === "" && (
        <div
          className={`ocl-searchby-container ${
            screenType !== "small"
              ? "ocl-section-container"
              : canShowSearchByComp
              ? ""
              : "width-zero"
          }`}
        >
          {canShowSearchByComp ? (
            <OnCallSearchByPage
              selectedData={dataFromInputComp}
              getCancelAction={(value) => searchByCancelAction()}
              getOptionChangedAction={(value) => {
                searchByOptionChangedAction();
              }}
              getOkAction={(data) => {
                setSelectedGuid(data);
                mapOnCallResultData(data);
              }}
              favCardData={props.favCardData}
              favFlag={favFlag}
              setFavFlag={setFavFlag}
            />
          ) : (
            ""
          )}
        </div>
      )}

      {AddProviderContextData.fromComponent === "" && (
        <div
          className={`ocl-search-result-container ${
            screenType !== "small"
              ? "ocl-section-container"
              : canShowSearchResComp
              ? ""
              : "width-zero"
          }`}
        >
          {canShowSearchResComp ? (
            <OnCallSearchResult
              dataFromComponent={fromComponent}
              userSelectedData={dataToSearchResComp}
              backBtnClicked={(flag: boolean) => backBtnClicked(flag)}
              pId={props.pId}
              isFromCaseHistory={props.isFromCaseHistory}
              updateAPICall={updateDetailsPage}
              
            />
          ) : (
            ""
          )}
        </div>
      )}
    </div>
  );
};

export default OnCallLookUpMainContent;
